export default __webpack_public_path__ + "files/Aleski_Thesis-fe433dd9f7051a0f91378ea8a61e54a2.pdf";